import { useState, useEffect } from 'react';
import { ELDLocationView } from '../components/tracking/ELDLocationView';
import { ELDHoursView } from '../components/tracking/ELDHoursView';

interface ELDPageProps {
  initialTab?: 'locations' | 'hours';
}

export default function ELDPage({ initialTab }: ELDPageProps) {
  const [activeTab, setActiveTab] = useState<'locations' | 'hours'>(initialTab || 'locations');
  
  useEffect(() => {
    if (initialTab) {
      setActiveTab(initialTab);
    }
  }, [initialTab]);

  return (
    <div>
      {activeTab === 'locations' && <ELDLocationView />}
      {activeTab === 'hours' && <ELDHoursView />}
    </div>
  );
}
